import { defineMessages } from "react-intl";

export const messages = defineMessages({
  dayDateFromNow: {
    id: "dayDateFromNow",
    defaultMessage: "{count} day ago",
  },
  dayDateFromNowPlural: {
    id: "dayDateFromNowPlural",
    defaultMessage: "{count} days ago",
  },
  monthDateFromNow: {
    id: "monthDateFromNow",
    defaultMessage: "{count} month ago",
  },
  monthDateFromNowPlural: {
    id: "monthDateFromNowPlural",
    defaultMessage: "{count} months ago",
  },
  yearDateFromNow: {
    id: "yearDateFromNow",
    defaultMessage: "{count} year ago",
  },
  yearDateFromNowPlural: {
    id: "yearDateFromNowPlural",
    defaultMessage: "{count} years ago",
  },
});
